import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Proof({ settings }) {
  const testimonials = settings?.testimonials || [];
  const faqs = settings?.faqs || [];
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="proof-section" className="py-12 md:py-16">
      <div className="mx-auto w-[min(1180px,calc(100%-32px))] grid lg:grid-cols-2 gap-12 lg:gap-16">
        <div data-testid="testimonials-section">
          <div className="eyebrow-label mb-4">From the Forgers</div>
          <h2 className="headline text-3xl sm:text-4xl lg:text-5xl mb-7">
            <span className="text-white">Words from </span>
            <span className="text-ember">the fire</span>
          </h2>
          <div className="space-y-2.5">
            {testimonials.map((t, i) => (
              <motion.figure
                key={i}
                data-testid={`testimonial-${i}`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="panel rounded-2xl px-5 py-4 hover:border-ember/40 transition-colors"
              >
                <blockquote className="text-[13px] leading-relaxed text-white/75">“{t.quote}”</blockquote>
                <figcaption className="display text-[10px] tracking-[0.2em] text-forge mt-2">
                  {t.name}
                  {t.meta && <span className="text-white/25 ml-2 tracking-normal">{t.meta}</span>}
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>

        <div data-testid="faq-section">
          <div className="eyebrow-label mb-4">Questions</div>
          <h2 className="headline text-3xl sm:text-4xl lg:text-5xl mb-7">
            <span className="text-white">Before you </span>
            <span className="text-forge">roll</span>
          </h2>
          <div className="border-t border-white/10">
            {faqs.map((faq, i) => (
              <div key={i} className="border-b border-white/10">
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-5 py-4 text-left group"
                >
                  <span className="display text-sm md:text-base tracking-wide text-white group-hover:text-ember transition-colors">
                    {faq.q}
                  </span>
                  <span
                    className={`text-forge text-xl leading-none transition-transform duration-300 ${
                      open === i ? "rotate-45" : ""
                    }`}
                  >
                    +
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      data-testid={`faq-answer-${i}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="text-[13px] text-white/50 leading-[1.8] pb-5 max-w-[520px]">{faq.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
